import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../../services/reports.service';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';

@Component({
  selector: 'app-runningbets',
  templateUrl: './runningbets.component.html',
  styleUrls: ['./runningbets.component.scss'],
})
export class RunningbetsComponent implements OnInit {
  constructor(private reprotServ: ReportsService) {}

  GROSS: any = 0;
  drawtime: any = [
    {
      value: 'All',
    },
    {
      value: '11AM',
    },
    {
      value: '2PM',
    },
    {
      value: '4PM',
    },
    {
      value: '5PM',
    },
    {
      value: '9PM',
    },
  ];
;
  selecteddrawtime: any = 'All';

  
  games: any = [
    {
      value: 'All',
    },
    {
      value: 'P138',
    },
    {
      value: 'P131',
    },
    {
      value: '3D',
    },
  ]
  selectedgames: any = 'All';
  
  group: any = [
    {
      value: 'All',
    },
    {
      value: 'JM',
    },
    {
      value: 'JACK',
    },
    {
      value: 'TEST',
    },
  ];
  selectedgroup: any = 'All';

  date!: Date;
  totalbets: any;
  visible: any;
  Code: any;
  Name: any;
  exportdata: any;

  ngOnInit() {
    this.date = new Date(moment().format('MM/DD/yyyy'));
    this.LoadRunninnBets();
  }

  // LoadBets = () => {};
  LoadRunninnBets = () => {
    let newdate = this.date
      ?.toLocaleDateString('ja-JP', {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replaceAll('/', '-');
    let data = {
      date: newdate,
      drawtime: this.selecteddrawtime,
      group: this.selectedgroup,
      games: this.selectedgames,
    };
    this.reprotServ.getRunningBets(data).subscribe((res) => {
      this.GROSS = res.length != 0 ? res[0].GrossTotal : 0;
      this.totalbets = res;
      console.log(res);
      // this.exportdata = res.map((row: any) => {
      //   return {
      //     Running_bets:
      //       row.drawtype == '3Dr'
      //         ? row.combination + '-r' + row.total
      //         : row.combination + '-' + row.total,
      //   };
      // });
      this.exportdata = res
      // this.exportdata.push({ Running_bets: res[0].GrossTotal });
    });
  };

  exportExcel() {
    let newdate =
      'Running_Bets_' +
      this.date
        ?.toLocaleDateString('ja-JP', {
          timeZone: 'Asia/Manila',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .replaceAll('/', '-');
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.exportdata);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, newdate);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + `_${this.selecteddrawtime}`);
  }
}
